import React from 'react'
import { fetchAd } from 'careers/actions/job-ad'
import JobAdComponent from 'careers/containers/job-ad'
import FetchWithSpinner from 'components/fetch-with-spinner'

/**
 * Single Job Ad view on careers pages
 */

interface JobAdProps {
  params: {
    language: string
    companySlug: string
    jobadSlug: string
  }
}
function JobAd(props: JobAdProps) {
  return (
    <FetchWithSpinner action={() => fetchAd(props.params)}>
      <JobAdComponent {...props} />
    </FetchWithSpinner>
  )
}

export default JobAd
